import React, { useEffect, useState } from "react";
import Container from "@material-ui/core/Container";
import Carousel, { CarouselItem } from "../../../../Components/Carousel";
import useTheme from "@material-ui/core/styles/useTheme";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery/useMediaQuery";
import { stripHTMLFromString } from "../../../../../utils";

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    width: "100%",
    position: "relative",
    overflow: "hidden",
    paddingTop: "calc(437 / 800 * 100%)",
    "&.square-image": {
      paddingTop: "calc( 248 / 280 * 100%)",
    },
    "& > img": {
      position: "absolute",
      left: 0,
      top: 0,
      height: "100%",
    },
  },
  slideContainer: {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
  },
  slideTextContainer: {
    textAlign: "center",
    "& > button": {
      paddingRight: theme.spacing(6),
      paddingLeft: theme.spacing(6),
    },
  },
  navigation: {
    margin: "10px",
    display: "flex",
    justifyContent: "center",
    "& > ul": {
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li": {
        display: "inline-block",
        margin: "0 5px",
        "& > button": {
          border: "none",
          boxSizing: "border-box",
          width: "8px",
          height: "8px",
          borderRadius: "4px",
          padding: 0,
          backgroundColor: "#b1b1b1",
          "&.activeButton": {
            backgroundColor: "black",
          },
        },
      },
    },
  },
}));

export default ({ data }) => {
  const [slideNum, setSlideNum] = useState(0);
  const [stopped, setStopped] = useState(false);
  const [carouselPos, setCarouselPos] = useState(0);
  const classes = useStyles();

  const handleSetSlideNum = (slideNum) => {
    setSlideNum(slideNum);

    // If we choose slide, stop auto switch:
    setStopped(true);
  };

  const onCarouselChange = (slideNum) => {
    setSlideNum(slideNum);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setSlideNum((slideNum) => {
        if (stopped) {
          return;
        }

        let newSlideNum = slideNum + 1;
        if (newSlideNum > data.slides.length - 1) {
          newSlideNum = 0;
        }
        return newSlideNum;
      });
    }, data.duration * 1000 || 5000);
    return () => clearInterval(interval);
  }, [stopped, slideNum]);

  // This shouldn't happen:
  if (data.slides.length == 0) {
    return null;
  }

  return (
    <Container disableGutters={true}>
      <Carousel
        slideIndex={slideNum}
        onChange={onCarouselChange}
        onUpdate={(pos) => setCarouselPos(pos)}
      >
        {data.slides.map((slide, idx) => {
          return (
            <CarouselItem key={idx}>
              <Slide
                slide={data.slides[idx]}
                currentSlideNum={slideNum}
                numSlides={data.slides.length}
                setSlideNum={setSlideNum}
              />
            </CarouselItem>
          );
        })}
      </Carousel>
      <Container disableGutters={true} className={"slide-text-container"}>
        <div className={classes.navigation}>
          <ul>
            {Array.from(Array(data.slides.length)).map((val, idx) => {
              return (
                <li key={idx}>
                  <button
                    className={idx == slideNum ? "activeButton" : ""}
                    onClick={() => setSlideNum(idx)}
                  />
                </li>
              );
            })}
          </ul>
        </div>
        <div className={classes.slideTextContainer}>
          <h2>{stripHTMLFromString(data.slides[slideNum].title)}</h2>
          <p>{stripHTMLFromString(data.slides[slideNum].text)}</p>
          {data.slides[slideNum].button.text && (
            <Button
              color="Primary"
              variant="contained"
              href={data.slides[slideNum].button.link}
            >
              {data.slides[slideNum].button.text}
            </Button>
          )}
        </div>
      </Container>
    </Container>
  );
};

export const Slide = ({ slide, currentSlideNum, numSlides, setSlideNum }) => {
  const classes = useStyles();
  const theme = useTheme();
  const squareImage = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <div className={classes.slideContainer}>
      <div
        className={`${classes.imageContainer} ${
          squareImage ? "square-image" : ""
        }`}
      >
        <img src={slide.background} />
      </div>
    </div>
  );
};
